import React from 'react';

export default ({ handleClose, show, children }) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";
  const handleOnClick = (e) => {
    if (e.target === e.currentTarget) handleClose()
  }

  return (
      <div className={showHideClassName} onClick={handleOnClick}>
        {children}
      </div>
  )
}